/* ============================================================================
 * ตัวเลือกคงที่ของหน้าเว็บฝั่งลูกค้า
 *
 * ไฟล์นี้เก็บเฉพาะ "ตัวเลือกของ UI" ที่ไม่ใช่เนื้อหา — เนื้อหาทั้งหมดของหน้าแรก
 * (ภาพพื้นหลัง หมวดหมู่ แบนเนอร์ ไลฟ์สไตล์ แนวรถไฟฟ้า จุดเด่น บทความ แถบติดต่อ)
 * มาจาก API แล้ว ดู page/homepage/api.js
 *
 * ทำเล (zones) และประเภททรัพย์ (types) ของกล่องค้นหาก็มาจาก API เช่นกัน
 * เพราะต้องเป็นทำเล/ประเภทที่มีทรัพย์อยู่จริง ไม่ใช่รายการที่ hardcode ไว้
 * ========================================================================== */
import { alert, t } from "../../components/CustomComponent.js";
import { lineAddUrl } from "../../components/people_option.js";
import { loadPost } from "../../services/home_post.service.js";

/* ---------------------------------------------------------------- เมนูหลัก */
export const NAV_LINKS = [
  { key: "home", label: "home_nav_home", href: "#hm-top" },
  { key: "rent", label: "home_nav_rent", href: "#hm-featured" },
  { key: "sale", label: "home_nav_sale", href: "#hm-featured" },
  { key: "project", label: "home_nav_projects", href: "#hm-projects" },
  { key: "featured", label: "home_nav_featured", href: "#hm-featured" },
  { key: "article", label: "home_nav_articles", href: "#hm-articles" },
  { key: "about", label: "home_nav_about", href: "#hm-about" },
  { key: "contact", label: "home_nav_contact", href: "#hm-contact" },
];

/** พาไปยังส่วนหนึ่งของหน้าแรกจากที่ไหนก็ได้ (เมนูบน / ฟุตเตอร์ ใช้ตัวเดียวกัน)
 *  - อยู่หน้าที่มีส่วนนั้น : เลื่อนไปหา (เผื่อความสูงแถบเมนูที่ติดหัวจอไว้ 90px)
 *  - อยู่หน้าอื่น (เช่น หน้ารายละเอียดทรัพย์ / หน้ารายการ) : พากลับหน้าแรกพร้อม
 *    #anchor แล้วหน้าแรกจะเลื่อนให้เองหลังโหลดเนื้อหาเสร็จ */
export const goSection = (href) => {
  /* เช็กว่าอยู่หน้าไหนก่อนค้นหา element เพราะหน้าอื่นก็วางเมนู/ฟุตเตอร์ชุดเดียวกัน
     จึงมี id ซ้ำอยู่ (#hm-top ของเมนู) — ถ้าเลื่อนหาเลยจะกลายเป็นเลื่อนขึ้นบนหน้าเดิม
     แทนที่จะพากลับหน้าแรกตามที่ผู้ใช้กด */
  if (window.location.pathname !== "/") {
    window.location.href = `/${href}`;
    return;
  }
  const target = href && document.querySelector(href);
  if (target) return window.scrollTo({ top: target.offsetTop - 90, behavior: "smooth" });
  window.scrollTo({ top: 0, behavior: "smooth" });
};

/* -------------------------------------------------- ตัวเลือกในกล่องค้นหา */
/* ประเภทประกาศ — ค่าที่ส่งไปเป็นเงื่อนไขค้นหา ไม่ได้ผูกกับตารางในฐานข้อมูล */
export const DEAL_OPTIONS = [
  { value: "sale", label: "home_deal_sale" },
  { value: "rent", label: "home_deal_rent" },
];

/* ช่วงราคาเป็นการจัดกลุ่มเพื่อให้เลือกง่าย ไม่ใช่ข้อมูลจากฐานข้อมูล จึงคงไว้ที่นี่
   value = "min-max" (บาท) ปล่อยว่างข้างไหน = ไม่จำกัดด้านนั้น — ส่งเป็นเงื่อนไขค้นหาได้ตรง ๆ
   ประกาศเช่าเทียบกับค่าเช่าต่อเดือน ประกาศขายเทียบกับราคาขาย */
export const PRICE_OPTIONS = {
  rent: [
    { value: "-15000", label: "ต่ำกว่า 15,000" },
    { value: "15000-30000", label: "15,000 - 30,000" },
    { value: "30000-60000", label: "30,000 - 60,000" },
    { value: "60000-100000", label: "60,000 - 100,000" },
    { value: "100000-", label: "100,000 ขึ้นไป" },
  ],
  sale: [
    { value: "-3000000", label: "ต่ำกว่า 3 ล้าน" },
    { value: "3000000-5000000", label: "3 - 5 ล้าน" },
    { value: "5000000-10000000", label: "5 - 10 ล้าน" },
    { value: "10000000-30000000", label: "10 - 30 ล้าน" },
    { value: "30000000-", label: "30 ล้านขึ้นไป" },
  ],
};

/** "-15000" -> { price_min: "", price_max: "15000" } (ค่าว่าง = ไม่จำกัด) */
export const priceRange = (value) => {
  const [min, max] = String(value || "").split("-");
  return { price_min: min || "", price_max: max || "" };
};

/* ห้องนอน — studio = ไม่มีห้องนอนแยก, 4+ = ตั้งแต่ 4 ห้องขึ้นไป (bed_min) */
export const BED_OPTIONS = [
  { value: "studio", label: "home_opt_studio" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4+", label: "4+" },
];

/** "4+" -> { bed: "4", bed_min: true } */
export const bedFilter = (value) => {
  const bed = String(value || "").trim();
  if (!bed) return {};
  if (bed === "studio") return { bed: "studio" };
  return bed.endsWith("+") ? { bed: bed.slice(0, -1), bed_min: "true" } : { bed };
};

/* ============================================================================
 * ทางลัดค้นหา — หมวดหมู่ยอดนิยม / ค้นหาตามไลฟ์สไตล์ / แนวรถไฟฟ้า
 *
 * ปลายทางของแต่ละปุ่มตั้งไว้ที่หลังบ้าน (/ad/home/shortcuts) เป็นข้อความสั้น ๆ
 * รูปแบบ "key=value" เช่น tag=transit / type=condo / line=mrt-blue
 * ตารางนี้เป็นที่เดียวที่แปลงปลายทางนั้นเป็นเงื่อนไขจริงของ API
 *
 * ปุ่มที่ไม่ได้อยู่ในตาราง จะถูกตีความตามรูปแบบ key=value ตรง ๆ (type= / tag=)
 * ส่วนปลายทางที่ไม่เข้าคีย์ไหนเลย (เช่น line=bts-sukhumvit ของแนวรถไฟฟ้า) ถือเป็น
 * "แท็ก" ของทรัพย์ — ปุ่มแนวรถไฟฟ้าจึงกรองด้วยแท็กที่ผู้ดูแลติดไว้กับทรัพย์จริง
 * ไม่ใช่ค้นด้วยข้อความ ซึ่งไปโดนประกาศที่แค่เอ่ยชื่อสายไว้ในรายละเอียดด้วย
 * (แท็กที่มีทรัพย์อยู่จริงเลือกได้จากหน้า /ad/home/shortcuts — GET admin/assets/tags)
 * ========================================================================== */
export const SHORTCUT_PRESETS = {
  // ใกล้รถไฟฟ้า = ติดแท็กใกล้ MRT หรือใกล้ BTS อย่างใดอย่างหนึ่ง
  "tag=transit": { tags: "near_mrt,near_bts" },
  // เลี้ยงสัตว์ได้เป็นข้อมูลของทรัพย์โดยตรงแล้ว ไม่ใช่แท็ก (ดูคอลัมน์ pet_allowed)
  "tag=pet": { pet: "true" },
  "tag=campus": { tags: "near_university" },
  "tag=invest": { tags: "invest" },
  // บ้านทำ Home Office = ทาวน์เฮาส์ / ทาวน์โฮม
  "type=office": { types: "townhouse,townhome" },
};

/** ปุ่มทางลัด 1 ปุ่ม -> เงื่อนไขที่ส่งให้หน้ารายการทรัพย์ */
export const shortcutParams = (item = {}) => {
  const target = String(item.target || "").trim();
  if (SHORTCUT_PRESETS[target]) return SHORTCUT_PRESETS[target];

  /* ไม่ได้ตั้งปลายทางไว้ — ยังต้องพาไปที่ไหนสักที่ ใช้ชื่อปุ่มเป็นคำค้นแทน
     ฝั่ง API ค้นครอบทั้งคีย์เวิร์ด แท็ก และจุดสนใจใกล้เคียงอยู่แล้ว */
  if (!target) return { q: item.sub || item.label || item.name || "" };

  /* ไม่ได้ใส่ key= มา (พิมพ์แค่ "bts_sukhumvit") ถือว่าเป็นแท็กเลย
     ผู้ดูแลจะได้เลือกจากรายการแท็กที่มีอยู่จริงมาวางได้ตรง ๆ */
  const at = target.indexOf("=");
  const key = at === -1 ? "tag" : target.slice(0, at).trim();
  const value = (at === -1 ? target : target.slice(at + 1)).trim();
  if (!value) return { q: item.sub || item.label || item.name || "" };

  if (key === "type") return { type: value };
  if (key === "types") return { types: value };
  if (key === "pet") return { pet: value };

  /* ที่เหลือทั้งหมด (tag= / tags= / line= ของแนวรถไฟฟ้า / คีย์ที่ยังไม่รู้จัก)
     กรองด้วยแท็กของทรัพย์ — คั่นด้วยลูกน้ำได้ ติดแท็กใดแท็กหนึ่งก็เข้าเงื่อนไข */
  return { tags: value };
};

/** ชื่อที่โชว์เป็นหัวข้อหน้ารายการ — ใช้ชื่อปุ่มที่ผู้ใช้กด ไม่ใช่ค่าปลายทางดิบ ๆ */
export const shortcutTitle = (item = {}) => [item.label || item.name, item.sub].filter(Boolean).join(" ");

/* --------------------------------------------------------- สถานะของทรัพย์ */
/* ป้ายมุมซ้ายบนของการ์ด — บอกว่ายังติดต่อได้ไหม (ค่ามาจากสถานะจริงของประกาศ)
   key ต้องตรงกับ PROPERTY_STATUS ฝั่งแอดมิน (components/asset_option.js)
   สีใช้คลาสสำเร็จของหน้าเว็บลูกค้า (.hm-badge--*) ให้โทนเดียวกับป้ายหลังบ้าน */
export const PROPERTY_STATUS = {
  available: { label: "home_status_available", color: "green" },
  reserved: { label: "home_status_reserved", color: "yellow" },
  processing: { label: "home_status_processing", color: "blue" },
  sold: { label: "home_status_sold", color: "red" },
  rented: { label: "home_status_rented", color: "purple" },
  off_market: { label: "home_status_off_market", color: "ink" },
};

export const homeStatusMeta = (value) => PROPERTY_STATUS[value] || PROPERTY_STATUS.available;

/* ------------------------------------------------------ ตัวเลือกการเรียง */
export const SORT_OPTIONS = [
  { value: "recommend", label: "home_sort_recommend" },
  { value: "new", label: "home_sort_new" },
  { value: "price_asc", label: "home_sort_price_asc" },
  { value: "price_desc", label: "home_sort_price_desc" },
  { value: "popular", label: "home_sort_popular" },
];

/* ------------------------------------------------- ช่องทางติดต่อบนแถบท้ายหน้า */
/* โทร / LINE / อีเมล ยึดจาก "ตั้งค่า › ข้อมูลบริษัท" ที่เดียว ไม่ให้ตั้งซ้ำที่หน้า
   จัดการหน้าแรก — ถ้ามีสองที่ วันที่บริษัทย้ายออฟฟิศหรือเปลี่ยนเบอร์ จะมีที่หนึ่ง
   ที่ลืมแก้เสมอ แล้วลูกค้าโทรไปเบอร์ที่ไม่มีคนรับ

   รายการที่ตั้งไว้ที่ /ad/home/contact ยังใช้ได้กับช่องทางที่ไม่ใช่สามอันนี้
   (ที่อยู่ / เวลาทำการ) ซึ่งเป็นข้อมูลบอกเล่า ไม่ใช่ปุ่มที่กดแล้วติดต่อได้ทันที */
export const COMPANY_CHANNEL_KINDS = ["phone", "line", "mail"];

/**
 * รวมช่องทางติดต่อที่จะแสดงบนแถบติดต่อ (HomeCta)
 * @param {Object} company - ข้อมูลจาก services/company.service.js
 * @param {Array} items - ช่องทางที่ตั้งไว้หลังบ้าน (contact.bar.items)
 * @returns {Array<{key:string, kind:string, value:string}>}
 */
export const contactChannels = (company = {}, items = []) => {
  // เบอร์สำนักงานเป็นหลัก ไม่มีค่อยใช้สายด่วน — อย่างน้อยต้องมีเบอร์ให้กดหนึ่งเบอร์
  const phone = (company.phone || company.hotline || "").trim();
  const line = (company.line_oa || "").trim();
  const mail = (company.email || "").trim();

  return [
    ...(phone ? [{ key: "phone", kind: "phone", value: phone }] : []),
    ...(line ? [{ key: "line", kind: "line", value: line }] : []),
    ...(mail ? [{ key: "mail", kind: "mail", value: mail }] : []),
    ...(items || [])
      .filter((item) => item.is_active !== false && !COMPANY_CHANNEL_KINDS.includes(item.kind))
      .map((item) => ({ key: item.uid, kind: item.kind, value: item.value })),
  ];
};

/* ------------------------------------------------------------ ลงประกาศฟรี */

/**
 * กดปุ่ม "ลงประกาศฟรี" จากที่ไหนก็ตาม (เมนูบน / การ์ดข้างแบนเนอร์ / ฟุตเตอร์)
 *
 * ระบบยังไม่มีหน้าลงประกาศของตัวเอง ผู้สนใจจึงถูกพาไปคุยกับทีมงานทาง LINE แทน
 * โดยใช้ LINE ID ที่ตั้งไว้ที่ "จัดการหน้าแรก › ลงประกาศฟรี"
 *
 * ถามยืนยันก่อนเสมอ (แบบเดียวกับช่องทาง LINE ในแถบติดต่อ) เพราะปุ่มนี้อยู่บนเมนู
 * ที่ติดหัวจอตลอดเวลา กดพลาดแล้วสลับไปแอป LINE ทันทีจะสะดุดกว่าที่ควร
 * ยังไม่ได้ตั้ง LINE ID = ยังไม่มีปลายทางจริง จึงแจ้ง "กำลังพัฒนา" เหมือนก่อนหน้านี้
 */
export const openFreePost = async () => {
  // ค่าที่โหลดไว้แล้วคืนทันที (service กันยิงซ้ำให้) — ครั้งแรกสุดถึงจะรอ API จริง
  const { line_id } = await loadPost();
  const url = lineAddUrl(line_id);

  if (!url) {
    return alert("", "info", t("coming_soon_title"), `${t("home_promo_post_title")} — ${t("coming_soon_desc")}`, t("confirm"));
  }

  /* ไม่โชว์ LINE ID / ลิงก์ในคำถาม — ผู้ดูแลตั้งเป็นลิงก์ย่อได้ (เช่น lin.ee/xxxx)
     ซึ่งผู้ใช้อ่านแล้วไม่รู้ว่าเป็นบัญชีไหน มีแต่ทำให้กล่องคำถามรก */
  if (!(await alert("", "info", t("home_post_line_confirm"), "", t("home_contact_line_add"), t("cancel")))) return;
  window.open(url, "_blank", "noopener,noreferrer");
};

/* ------------------------------------------------------ สมัครเป็นพาร์ตเนอร์ */
export const PARTNER_PATH = "/partner";

/** เปิดหน้าใบสมัครพาร์ตเนอร์ (/partner)
 *
 *  เปิดในแท็บเดิม ต่างจากปุ่ม "ดูทั้งหมด" / รายการโปรด ที่เปิดแท็บใหม่ — การสมัคร
 *  เป็นงานที่ต้องทำให้จบทีเดียว ไม่ใช่การไล่ดูของควบคู่ไปกับหน้าแรก และหน้าใบสมัคร
 *  มีเมนู/ฟุตเตอร์ชุดเดียวกันอยู่แล้ว กลับหน้าแรกได้ตลอด
 *
 *  ต้องส่ง navigate ของ react-router มาด้วยเสมอเมื่อเรียกจากในหน้าเว็บ — เปลี่ยนหน้า
 *  ด้วย window.location คือการโหลด SPA ใหม่ทั้งก้อน (ตอน dev บันเดิลใหญ่ระดับสิบเมกะไบต์)
 *  หน้าจอจะขาวค้างหลายวินาทีจนดูเหมือนแอปแฮงก์ ส่วน window.location เก็บไว้เป็นทางสำรอง
 *  ให้ที่เรียกซึ่งไม่ได้อยู่ใต้ Router เท่านั้น
 */
/* เปลี่ยนหน้าแบบ client-side เมื่อทำได้ — เปลี่ยนด้วย window.location จะโหลดบันเดิล
   ใหม่ทั้งก้อนจนหน้าจอขาวค้าง ตัวที่ไม่มี navigate ให้ (เช่นฟุตเตอร์บางจุด) ค่อยตกไปใช้ทางเดิม */
const goPath = (path, navigate) => {
  if (typeof navigate === "function") return navigate(path);
  window.location.href = path;
};

export const openPartner = (navigate) => goPath(PARTNER_PATH, navigate);

/* หน้าย่อยของพาร์ตเนอร์ที่เปิดจากกล่องเข้าสู่ระบบ
   เก็บเส้นทางไว้ที่นี่ที่เดียวเหมือน PARTNER_PATH จะได้ไม่มีสตริงเส้นทางกระจายอยู่ในคอมโพเนนต์ */
export const PARTNER_FORGOT_PATH = "/partner/forgot-password";
export const PARTNER_STATUS_PATH = "/partner/status";

export const openPartnerForgot = (navigate) => goPath(PARTNER_FORGOT_PATH, navigate);
export const openPartnerStatus = (navigate) => goPath(PARTNER_STATUS_PATH, navigate);

/* --------------------------------------------------------------- ฟุตเตอร์ */
/* ลิงก์ในฟุตเตอร์ชี้ไปยังส่วนต่าง ๆ ของเว็บ เป็นโครงสร้างเว็บ ไม่ใช่เนื้อหา
   จึงไม่ได้เปิดให้แก้จากหลังบ้าน (ข้อความที่แก้ได้คือสโลแกน/ข่าวสาร)

   ปลายทางของแต่ละรายการมีได้ 3 แบบ — HomeFooter เลือกวิธีเปิดตามคีย์ที่ใส่ไว้
     href   ส่วนหนึ่งของหน้าแรก  -> goSection() ชุดเดียวกับเมนูบน
     path   หน้าเต็มของเว็บ      -> ลิงก์ปกติ (คัดลอก/เปิดแท็บใหม่ได้)
     action ไม่ใช่การเปิดหน้า    -> เรียกการกระทำที่ HomeFooter รู้จัก ("post")
                                    ชนิดที่ไม่รู้จักส่งกลับให้หน้าแม่ผ่าน props.onLink */

/** หยิบรายการจากเมนูบนมาใช้ซ้ำ — กดจากฟุตเตอร์แล้วต้องไปที่เดียวกับเมนูบนเป๊ะ */
const navLink = (key) => NAV_LINKS.find((item) => item.key === key);

export const FOOTER_LINKS = [
  {
    title: "home_footer_menu",
    items: ["home", "rent", "sale", "project", "featured"].map(navLink),
  },
  {
    title: "home_footer_service",
    items: [
      /* ลงประกาศฟรียังไม่มีหน้าปลายทางในระบบ (ระบบสมาชิกฝั่งลูกค้ายังไม่เปิด)
         จึงพาไปคุยกับทีมงานทาง LINE เหมือนปุ่มลงประกาศบนเมนูและข้างแบนเนอร์ */
      { key: "post", label: "home_footer_post", action: "post" },
      /* ค้นหาทรัพย์/บทความ เปิดหน้าเต็มไปเลย ไม่ใช่เลื่อนไปบล็อกย่อในหน้าแรก
         เพราะคนที่เลื่อนมาถึงฟุตเตอร์คือคนที่ยังหาไม่เจอ — พาไปหน้าที่ค้นได้จริง */
      { key: "search", label: "home_footer_search", path: "/properties" },
      { key: "articles", label: "home_nav_articles", path: "/articles" },
      /* สมัครเป็นพาร์ตเนอร์มีหน้าของตัวเองแล้ว จึงเป็นลิงก์ปกติ ไม่ใช่ action */
      { key: "partner", label: "partner_cta", path: "/partner" },
    ],
  },
];
